import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Svg from './BaseIcon';
const CloseIcon = ({ className, testId, color, }) => {
    const { colors } = useTheme();
    const colorToApply = color || colors.text.default;
    return (_jsxs(Svg, { className: className, "data-cy": testId, width: "9", height: "9", viewBox: "0 0 9 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M1 7.60333L7.60333 1", stroke: colorToApply, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M7.60333 7.60333L1 1", stroke: colorToApply, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
export default CloseIcon;
//# sourceMappingURL=CloseIcon.js.map